/**
 * Gera PDF do lado do cliente via jsPDF + jspdf-autotable.
 *
 * O caller passa um `build(doc)` que desenha o miolo (geralmente
 * `autoTable(doc, { ... })`). Aqui aplicamos header/footer padrão
 * em TODAS as páginas DEPOIS do build, então o caller não precisa
 * se preocupar com paginação.
 */
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { drawHeader, drawFooter, CONTENT_START_Y, type ReportMeta } from './template';

export interface PdfBuildContext {
  doc: jsPDF;
  /** Y onde o conteúdo pode começar (já abaixo do header). */
  contentStartY: number;
}

export function downloadAsPdf(
  filename: string,
  meta: ReportMeta,
  build: (ctx: PdfBuildContext) => void,
): void {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  // Desenha header na primeira página antes de qualquer conteúdo, e em
  // toda nova página via callback do autoTable. O build pode adicionar
  // páginas manualmente — header é redesenhado lá embaixo.
  const startY = drawHeader(doc, meta);

  build({ doc, contentStartY: Math.max(startY, CONTENT_START_Y) });

  // Re-aplica header em todas as páginas exceto a primeira (autoTable
  // usa `didDrawPage` hook quando configurado pelo caller; aqui
  // garantimos consistência em quem não usar o hook).
  const total = doc.getNumberOfPages();
  for (let i = 1; i <= total; i++) {
    doc.setPage(i);
    if (i > 1) drawHeader(doc, meta);
    drawFooter(doc, i, total);
  }

  doc.save(filename.endsWith('.pdf') ? filename : `${filename}.pdf`);
}
